<div class="position-relative h-100 d-flex flex-column">
  <app-section-loader [loading]="loading"></app-section-loader>
  <h2 class="mat-dialog-title" mat-dialog-title class="text-secondary">
    {{ dialogDataInstance?.action }}
  </h2>
  <mat-dialog-content *ngIf="dialogDataInstance?.action === 'Advance Grade'">
    <p class="modal-text m-0" *ngIf="selected1stGradeList.length > 0">
      {{ actionMessages?.ADVANCE_2ND_GRADE }}
    </p>
    <div class="list-name-scroll" *ngIf="selected1stGradeList.length > 0">
      <ul class="list-unstyled list-name">
        <li *ngFor="let student of selected1stGradeList">
          <span class="text">{{ student.UserName }} </span>
        </li>
      </ul>
    </div>
    <p class="modal-text m-0" *ngIf="selected2ndGradeList.length > 0">
      {{ actionMessages?.ADVANCE_3RD_GRADE }}
    </p>
    <div class="list-name-scroll" *ngIf="selected2ndGradeList.length > 0">
      <ul class="list-unstyled list-name">
        <li *ngFor="let student of selected2ndGradeList">
          <span class="text">{{ student.UserName }} </span>
        </li>
      </ul>
    </div>
    <p
      class="modal-text m-0"
      *ngIf="selected3rdGradeList.length > 0 || selected4thGradeList.length > 0"
    >
      {{ actionMessages?.ADVANCE_5TH_GRADE }}
    </p>
    <div
      class="list-name-scroll"
      *ngIf="selected3rdGradeList.length > 0 || selected4thGradeList.length > 0"
    >
      <ul class="list-unstyled list-name">
        <li *ngFor="let student of selected3rdGradeList">
          <span class="text">{{ student.UserName }} </span>
        </li>
        <li *ngFor="let student of selected4thGradeList">
          <span class="text">{{ student.UserName }} </span>
        </li>
      </ul>
    </div>
    <p class="modal-text m-0" *ngIf="selected5thGradeList.length > 0">
      {{ actionMessages?.ADVANCE_5TH_GRADE }}
    </p>
    <div class="list-name-scroll">
      <ul class="list-unstyled list-name">
        <li *ngFor="let student of selected5thGradeList">
          <span class="text">{{ student.UserName }} </span>
        </li>
      </ul>
    </div>
    <p class="text-center m-0 h3">{{ actionMessages?.CHANGE_ACCEPTANCE }}</p>
  </mat-dialog-content>
  <mat-dialog-content *ngIf="dialogDataInstance?.action === 'Revert Grade'">
    <div *ngIf="filteredStudentList.length">
      <p class="modal-text m-0" *ngIf="selected1stGradeList.length > 0">
        {{ actionMessages?.REVERT_1ST_GRADE }}
      </p>
      <div class="list-name-scroll">
        <ul class="list-unstyled list-name">
          <li *ngFor="let student of selected1stGradeList">
            <span class="text">{{ student.UserName }} </span>
          </li>
        </ul>
      </div>
      <p class="modal-text m-0" *ngIf="selected2ndGradeList.length > 0">
        {{ actionMessages?.REVERT_2ND_GRADE }}
      </p>
      <div class="list-name-scroll">
        <ul class="list-unstyled list-name">
          <li *ngFor="let student of selected2ndGradeList">
            <span class="text">{{ student.UserName }} </span>
          </li>
        </ul>
      </div>
      <p class="modal-text m-0" *ngIf="selected3rdGradeList.length > 0">
        {{ actionMessages?.REVERT_3RD_GRADE }}
      </p>
      <div class="list-name-scroll">
        <ul class="list-unstyled list-name">
          <li *ngFor="let student of selected3rdGradeList">
            <span class="text">{{ student.UserName }} </span>
          </li>
        </ul>
      </div>
      <p class="modal-text m-0" *ngIf="selected4thGradeList.length > 0">
        {{ actionMessages?.REVERT_4TH_GRADE }}
      </p>
      <div class="list-name-scroll">
        <ul class="list-unstyled list-name">
          <li *ngFor="let student of selected4thGradeList">
            <span class="text">{{ student.UserName }} </span>
          </li>
        </ul>
      </div>
      <p class="modal-text m-0" *ngIf="selected5thGradeList.length > 0">
        {{ actionMessages?.REVERT_5TH_GRADE }}
      </p>
      <div class="list-name-scroll">
        <ul class="list-unstyled list-name">
          <li *ngFor="let student of selected5thGradeList">
            <span class="text">{{ student.UserName }} </span>
          </li>
        </ul>
      </div>
    </div>
    <p class="text-center m-0 h3">{{ actionMessages?.CHANGE_ACCEPTANCE }}</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close (click)="dialogRef.close(false)">
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="confirmAction()"
      cdkFocusInitial
    >
      Yes
    </button>
  </mat-dialog-actions>
</div>
